import React from 'react';

import { DataTablePagingPage } from '../_Page/DataTablePagingPage';
import { Box } from '@src/atoms/Box';

interface IProps {
  list: (number | string)[];
  onPageChange: (page: number) => void;
  currentActivePage: number;
}
export const DataTablePageList = ({ onPageChange, list, currentActivePage }: IProps) => {
  return (
    <Box gap={4}>
      {list.map((item, index) => {
        const isPage = typeof item === 'number' && Number.isFinite(item);
        const isActive = item === currentActivePage;

        if (!isPage)
          return (
            <Box style={{ height: 32, width: 32 }} alignItems="center" justifyContent="center" key={index}>
              {item}
            </Box>
          );

        return <DataTablePagingPage currentPage={item} onPageChange={onPageChange} key={index} isActive={isActive} />;
      })}
    </Box>
  );
};
